export default "__VITE_ASSET__CBv4axJg__"